
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#f8f8f9","d":"M345.6 0H51.2v512h409.6V115.2z"}}),_c('path',{attrs:{"fill":"#ededed","d":"M345.6 115.2V0H256v512h204.8V115.2z"}}),_c('path',{attrs:{"fill":"#e07188","d":"M51.2 230.4h409.6v204.8H51.2z"}}),_c('path',{attrs:{"fill":"#e02753","d":"M256 230.4h204.8v204.8H256z"}}),_c('g',{attrs:{"fill":"#f8f8f9"}},[_c('path',{attrs:{"d":"M232.727 324.429V371.2h-18.89v-81.792h14.746l38.131 48.038v-48.038h18.894V371.2H270.4l-37.673-46.771zM136.308 371.2v-81.792h34.904c15.09 0 26.726 13.952 26.726 27.649 0 15.744-11.796 27.763-26.15 27.763H155.2v26.38h-18.892zm18.893-42.854h15.437c5.025 0 8.179-4.905 8.179-11.288 0-6.577-3.474-11.059-8.87-11.059H155.2v22.348h.001zM363.249 363.136c-6.221 5.76-13.403 8.64-21.542 8.64-22.506 0-39.283-18.496-39.283-42.049 0-23.808 18.938-40.895 40.781-40.895 16.091 0 26.996 7.127 32.718 17.855l-14.054 10.598c-4.426-8.006-11.466-11.635-19.354-11.635-11.633 0-20.966 10.349-20.966 24.769 0 13.74 8.854 24.538 21.772 24.538 7.375 0 14.016-3.418 19.931-10.254v-2.533h-15.899v-13.71h31.566v42.74H363.25v-8.064h-.001z"}})])])
          )
        }
      }
    